import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PageBackground from "@/components/PageBackground";
import { ArrowUpRight } from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);
  const styles = [
    "bg-gradient-to-br from-cyan-100 to-sky-100 border-cyan-200",
    "bg-gradient-to-br from-emerald-100 to-emerald-100 border-emerald-200",
    "bg-gradient-to-br from-emerald-100 to-teal-100 border-emerald-200",
    "bg-gradient-to-br from-rose-100 to-orange-100 border-rose-200",
  ];
  return (
    <div className="relative">
      <PageBackground variant="cyan-lav" />
      <div className="max-w-7xl mx-auto px-6 py-12 relative z-10">
        <div className="mb-10">
          <div className="pf-chip pf-chip-lav">Browse</div>
          <h1 className="font-display text-5xl md:text-6xl font-medium tracking-[-0.03em] mt-3 text-slate-900">Categories</h1>
        </div>
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
          {cats.map((c, i) => (
            <Link key={c.id} to={`/coupons?category=${c.slug}`} className={`pf-card p-6 flex flex-col justify-between h-44 relative overflow-hidden group ${styles[i % styles.length]}`} data-testid={`cat-${c.slug}`}>
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-600 font-semibold">{c.coupon_count} coupons</div>
              <div className="font-display text-2xl font-medium text-slate-900">{c.name}</div>
              <ArrowUpRight className="w-4 h-4 absolute top-4 right-4 text-slate-500 group-hover:text-slate-900 transition-colors" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
